import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from '../shared/shared.module';

import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { VerificationSendComponent } from './verification-send/verification-send.component';
import { RestPasswordComponent } from './rest-password/rest-password.component';
import { RestPasswordResolver } from './rest-password/rest-password.resolver';
import { MobileLandingComponent } from './mobile-landing/mobile-landing.component';
import {BlockAuthGuard} from '../core/guards/block-auth.guard';
import { AutoLoginComponent } from './auto-login/auto-login.component';
const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    canActivate: [BlockAuthGuard],
    children : [
      {
        path: '',
        component: MobileLandingComponent
      },
      {
        path: 'auto-login',
        component: AutoLoginComponent
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'sign-up',
        component: RegisterComponent
      },
      {
        path: 'forget-password',
        component: ForgetPasswordComponent
      },
      {
        path: 'reset-password/:token',
        component: RestPasswordComponent,
        resolve: {
          results: RestPasswordResolver
        }
      },
      {
        path: 'sign-up-success',
        component: VerificationSendComponent
      },
      {
        path: 'sign-up-success',
        component: VerificationSendComponent
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  declarations: [
    AuthComponent,
    LoginComponent,
    RegisterComponent,
    ForgetPasswordComponent,
    VerificationSendComponent,
    RestPasswordComponent,
    MobileLandingComponent,
    AutoLoginComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
  ],
  providers: [
    RestPasswordResolver
  ]
})
export class AuthModule { }
